"use client";

import { useState } from "react";
import { Icon } from "@iconify/react";
import { BannerSection } from "@/components/sections/BannerSection";
import { Breadcrumb } from "@/components/sections/Breadcrumb";
import { cgvArticles } from "@/data/cgv";
import { SectionTitlte } from "@/components/sections/SectionTitlte";

export default function CGVPage() {
  const [openArticles, setOpenArticles] = useState<number[]>(
    Array.from({ length: cgvArticles.length }, (_, index) => index)
  );

  const toggleArticle = (index: number) => {
    setOpenArticles((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const renderContent = (content: (typeof cgvArticles)[0]["content"]) => {
    return (
      <div className="flex flex-col gap-4 xl:gap-8">
        {content.map((item, idx) => {
          if (item.type === "paragraph") {
            return <p key={idx}>{item.content}</p>;
          }

          if (item.type === "list-item") {
            return (
              <div key={idx} className="flex items-start">
                <span className="mr-2">•</span>
                <div className="space-y-1">
                  <p className="font-semibold">{item.title}</p>
                  <p>{item.content}</p>
                </div>
              </div>
            );
          }

          if (item.type === "subsection") {
            return (
              <div key={idx} className="space-y-2">
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p>{item.content}</p>
              </div>
            );
          }

          return null;
        })}
      </div>
    );
  };

  return (
    <section>
      <BannerSection />
      <SectionTitlte
        title="Conditions Générales de Vente"
        className="px-4 ph:px-24 md:px-48 lg:px-72 xl:px-96 pt-8"
      />
      <Breadcrumb className="text-accent " />
      <div className="w-full px-4 pt-10 pb-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
        <div className="space-y-4 text-accent">
          {cgvArticles.map((article, index) => (
            <div key={article.id} className="border-b border-b-accent">
              <button
                onClick={() => toggleArticle(index)}
                className="flex w-full items-center justify-between text-left"
              >
                <p className="text-xl font-semibold">{article.title}</p>
                <Icon
                  icon="mdi:chevron-down"
                  className={`transform transition-transform duration-200 ${
                    !openArticles.includes(index) ? "rotate-90" : ""
                  }`}
                  width={40}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-200 ${
                  openArticles.includes(index) ? "mb-6" : "max-h-0"
                }`}
              >
                {renderContent(article.content)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
